<template>
    <v-card :color="category.color"
            @click="onClick"
            class="rounded-xl">
        <v-img
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          height="200px"
        >
            <v-icon v-text="category.icon"
                    class="pl-3"
                    x-large/>
            <v-card-title v-text="category.name"
                          class="text-h4"/>
        </v-img>
    </v-card>
</template>

<script>
export default 
{
   name: 'CategoryCard',

   mixins: [],

   components:
   {

   },

   data: () => ({
     
   }),

   props:
   {
      category:
      {
         type: Object,
         required: true
      }
   },

   computed:
   {
     
   },

   methods:
   {
     onClick()
     {
        this.$emit('click', this.category)
     }
   },

   mounted()
   {

   }
}
</script>